import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import { FC } from 'react'
import { UserService } from '../services/user'
import { Fa } from './Fa'

const SessionSummary: FC<SessionSummaryProps> = ({ session, name = true }) => {
  return (
    <>
      {name && (
        <Typography variant="h3" mb={1}>
          {session.category.name}
        </Typography>
      )}
      <List
        dense
        disablePadding
        sx={{
          '& .MuiListItem-root': {
            gap: 1,
          },
          '& .MuiListItemIcon-root, & .MuiListItemAvatar-root': {
            minWidth: 0,
          },
        }}
      >
        <ListItem disableGutters>
          <ListItemIcon>
            <Fa name="clock" size="md" color="secondary" />
          </ListItemIcon>
          <ListItemText
            primary={[
              dayjs(session.session_start_time_utc)
                .tz()
                .format('YYYY-MM-DD HH:mm'),
              dayjs(session.session_end_time_utc).tz().format('HH:mm'),
            ].join(' ~ ')}
          />
        </ListItem>
        <ListItem disableGutters>
          <ListItemAvatar>
            <Avatar
              src={session.staff.profile_picture}
              sx={{ fontSize: '1em', width: '1em', height: '1em' }}
            ></Avatar>
          </ListItemAvatar>
          <ListItemText primary={UserService.getFullName(session.staff)} />
        </ListItem>
        <ListItem disableGutters>
          <ListItemIcon>
            <Fa name="location-dot" size="md" color="secondary" />
          </ListItemIcon>
          <ListItemText primary={session.gym_room?.name || '-'} />
        </ListItem>
      </List>
    </>
  )
}

type SessionSummaryProps = {
  session: Dto.Session
  name?: boolean
}

export { SessionSummary }
export type { SessionSummaryProps }
